/* Techno Express - "Select Trip Rating" (11 oct 2026)
   Los switches ya no tienen la variante "Choose an option". Para que el cliente no compre 3A
   sin darse cuenta, el amperaje empieza sin elegir y el botón no agrega hasta que se elige.
   - Página de producto (pills): nada marcado, título "Select Trip Rating" al tamaño del SKU.
   - Quick add de colecciones (botones): nada marcado al abrir, botón "Select Trip Rating".
   - Quick add de recomendados (select): primera opción "Select Trip Rating".
   Si la URL trae ?variant= (ej. desde Google Shopping) se respeta esa elección. */
(function () {
  'use strict';
  if (window.__teTripRating) return;
  window.__teTripRating = true;

  var RX = /trip\s*rating/i;
  var AMP = /^\s*\d+(\.\d+)?\s*A\b/i;
  var PROMPT = 'Select Trip Rating';
  var hasVariantParam = /[?&]variant=\d+/.test(window.location.search);
  var pending = {};   /* formId -> true mientras falte elegir (página de producto) */
  var chosen = {};    /* formId -> true cuando el cliente ya eligió */

  var css = '' +
    '.te-tr-legend,.te-tr-legend span{text-transform:none!important;letter-spacing:.01em!important;line-height:1.35!important;font-weight:800!important}' +
    '.te-tr-legend.is-alert,.te-tr-legend.is-alert span,.te-tr-qa-legend.is-alert{color:#D92D20!important}' +
    '.te-tr-btn-pending{background:#f5f5f5!important;border-color:#d9d9d9!important;color:#6b7280!important;cursor:not-allowed!important}' +
    '.te-tr-select-alert{outline:2px solid #D92D20!important;outline-offset:1px}';
  function injectCss() {
    if (document.getElementById('te-trip-rating-css')) return;
    var st = document.createElement('style');
    st.id = 'te-trip-rating-css';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function skuFontSize(from) {
    var scope = (from && from.closest && from.closest('.tx-pdp, [id^="MainProduct-"], section')) || document;
    var el = scope.querySelector('.product__sku span:not(.product__sku-label)') ||
      scope.querySelector('.product__sku') ||
      document.querySelector('.product__sku span:not(.product__sku-label), .product__sku');
    var size = el ? window.getComputedStyle(el).fontSize : '';
    return size && size !== '0px' ? size : '14px';
  }

  function formButtons(formId) {
    var list = [];
    var form = document.getElementById(formId);
    if (form) form.querySelectorAll('button[name="add"], button[type="submit"]').forEach(function (b) { list.push(b); });
    document.querySelectorAll('button[form="' + formId + '"][name="add"]').forEach(function (b) { list.push(b); });
    document.querySelectorAll('[data-tx-sticky-add]').forEach(function (b) { list.push(b); });
    return list;
  }

  function labelNode(btn) {
    return btn.querySelector('[data-button-label]') || btn.querySelector('span') || btn;
  }

  function setPendingButton(btn, on) {
    var node = labelNode(btn);
    if (on) {
      if (!btn.hasAttribute('data-te-tr-label')) btn.setAttribute('data-te-tr-label', node.textContent);
      node.textContent = PROMPT;
      btn.classList.add('te-tr-btn-pending');
      btn.setAttribute('aria-disabled', 'true');
    } else if (btn.hasAttribute('data-te-tr-label')) {
      if (node.textContent === PROMPT) node.textContent = btn.getAttribute('data-te-tr-label');
      btn.removeAttribute('data-te-tr-label');
      btn.classList.remove('te-tr-btn-pending');
      btn.removeAttribute('aria-disabled');
    }
  }

  function markButtons(formId, on) {
    formButtons(formId).forEach(function (b) { setPendingButton(b, on); });
  }

  /* ---------- Página de producto ---------- */
  function initPdp() {
    document.querySelectorAll('variant-radios fieldset, variant-selects fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend, .product-form__group-name');
      if (!lg || !RX.test(lg.textContent)) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;
      var formId = radios[0].getAttribute('form') || '';
      var span = lg.querySelector('span') || lg;

      lg.classList.add('te-tr-legend');
      var size = skuFontSize(fs);
      lg.style.setProperty('font-size', size, 'important');
      if (span !== lg) span.style.setProperty('font-size', size, 'important');

      if (fs.getAttribute('data-te-tr') === '1') return;
      fs.setAttribute('data-te-tr', '1');
      if (!lg.hasAttribute('data-te-tr-orig')) lg.setAttribute('data-te-tr-orig', span.textContent);

      if (!hasVariantParam && formId && !chosen[formId]) {
        radios.forEach(function (r) { r.checked = false; });
        pending[formId] = true;
        span.textContent = PROMPT;
        lg.classList.add('is-pending');
        markButtons(formId, true);
      }

      fs.addEventListener('change', function (e) {
        if (!e.target || e.target.type !== 'radio') return;
        delete pending[formId];
        chosen[formId] = true;
        document.querySelectorAll('.te-tr-legend.is-pending').forEach(function (l) {
          var s = l.querySelector('span') || l;
          s.textContent = l.getAttribute('data-te-tr-orig') || 'Trip Rating:';
          l.classList.remove('is-pending', 'is-alert');
        });
        markButtons(formId, false);
      }, true);
    });
    /* Botones que el tema vuelve a pintar mientras sigue pendiente */
    Object.keys(pending).forEach(function (id) {
      formButtons(id).forEach(function (b) { if (!b.classList.contains('te-tr-btn-pending')) setPendingButton(b, true); });
    });
  }

  function alertPdp() {
    var lg = document.querySelector('.te-tr-legend.is-pending');
    if (!lg) return;
    lg.classList.add('is-alert');
    try { lg.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { lg.scrollIntoView(); }
  }

  /* ---------- Quick add con botones (colecciones) ---------- */
  function tripGroup(dialog) {
    var groups = dialog.querySelectorAll('[data-option-groups] fieldset');
    for (var i = 0; i < groups.length; i++) {
      var lg = groups[i].querySelector('legend');
      if (lg && RX.test(lg.textContent)) return groups[i];
    }
    return null;
  }

  function onDialogOpen(dialog) {
    var fs = tripGroup(dialog);
    if (!fs) return;
    var lg = fs.querySelector('legend');
    if (!lg.hasAttribute('data-te-tr-orig')) lg.setAttribute('data-te-tr-orig', lg.textContent);
    lg.classList.add('te-tr-qa-legend');
    lg.classList.remove('is-alert');
    lg.textContent = PROMPT;
    fs.querySelectorAll('[data-option-button]').forEach(function (b) { b.classList.remove('is-selected'); });
    var pos = Number(fs.getAttribute('data-option-position') || 1) - 1;
    if (Array.isArray(dialog._txSelectedOptions)) dialog._txSelectedOptions[pos] = undefined;
    dialog.setAttribute('data-te-tr-pending', '1');
    dialog.querySelectorAll('[data-add-button]').forEach(function (b) { setPendingButton(b, true); });
  }

  function onDialogChoice(dialog) {
    if (dialog.getAttribute('data-te-tr-pending') !== '1') return;
    dialog.removeAttribute('data-te-tr-pending');
    var fs = tripGroup(dialog);
    if (fs) {
      var lg = fs.querySelector('legend');
      lg.textContent = lg.getAttribute('data-te-tr-orig') || 'Trip Rating';
      lg.classList.remove('is-alert');
    }
    dialog.querySelectorAll('[data-add-button]').forEach(function (b) { setPendingButton(b, false); });
  }

  /* ---------- Quick add con select (recomendados) ---------- */
  function initSelects() {
    document.querySelectorAll('select[name="id"]').forEach(function (sel) {
      if (sel.getAttribute('data-te-tr') === '1') return;
      if (!sel.closest('dialog, .te-quick-add, .tx-quick-add')) return;
      var opts = Array.prototype.filter.call(sel.options, function (o) { return o.value !== ''; });
      if (opts.length < 2) return;
      var allAmp = opts.every(function (o) { return AMP.test(o.textContent); });
      if (!allAmp) return;
      sel.setAttribute('data-te-tr', '1');
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = PROMPT;
      ph.disabled = true;
      sel.insertBefore(ph, sel.firstChild);
      sel.value = '';
      ph.selected = true;
      sel.required = true;
      sel.addEventListener('change', function () { sel.classList.remove('te-tr-select-alert'); });
    });
  }

  /* ---------- Frenos ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var fid = form.getAttribute('id');
    if (fid && pending[fid]) {
      e.preventDefault(); e.stopImmediatePropagation(); alertPdp(); return;
    }
    var dialog = form.closest('dialog');
    if (dialog && dialog.getAttribute('data-te-tr-pending') === '1') {
      e.preventDefault(); e.stopImmediatePropagation();
      var fs = tripGroup(dialog);
      if (fs) fs.querySelector('legend').classList.add('is-alert');
      return;
    }
    var sel = form.querySelector('select[name="id"][data-te-tr="1"]');
    if (sel && !sel.value) {
      e.preventDefault(); e.stopImmediatePropagation();
      sel.classList.add('te-tr-select-alert');
      try { sel.focus(); } catch (err) {}
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opt = t.closest('[data-option-button]');
    if (opt) {
      var dlg = opt.closest('dialog');
      if (dlg) setTimeout(function () { onDialogChoice(dlg); }, 0);
      return;
    }
    var btn = t.closest('button[name="add"], [data-tx-sticky-add], [data-add-button]');
    if (!btn) return;
    var form = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
    var id = form && form.getAttribute && form.getAttribute('id');
    var isSticky = btn.hasAttribute('data-tx-sticky-add');
    var dialog = btn.closest('dialog');
    var blocked = (id && pending[id]) || (isSticky && Object.keys(pending).length > 0) ||
      (dialog && dialog.getAttribute('data-te-tr-pending') === '1');
    if (blocked) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (dialog) {
        var fs = tripGroup(dialog);
        if (fs) fs.querySelector('legend').classList.add('is-alert');
      } else {
        alertPdp();
      }
    }
  }, true);

  /* ---------- Arranque y cambios del DOM ---------- */
  var timer = null;
  function run() { initPdp(); initSelects(); }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 60); }

  function start() {
    injectCss();
    run();
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes' && r.attributeName === 'open' && r.target.nodeName === 'DIALOG' && r.target.hasAttribute('open')) {
          onDialogOpen(r.target);
        }
      }
      schedule();
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
